import React from 'react';
import { m } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { methodSteps } from '../../data/method';
export function Method() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-159" data-mp="2ao7lnam48r2j">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-160" data-mp="26nnlrza5r9cp">
        <SectionTag icon="🎯" data-id="element-161" data-mp="26nfaucxlie45">El método "Mira y Pita"</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-ink sm:text-4xl" data-id="element-162" data-mp="21pm2pecqfa18">
          El Método "Mira y Pita"
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-163" data-mp="1rqeroxtgzrha">
          Preparar tu próxima clase puede ser así de sencillo:
        </p>
      </div>

      <div className="mx-auto mt-8 flex max-w-4xl flex-col gap-4 px-4 sm:flex-row sm:items-stretch sm:gap-3 sm:px-6" data-id="element-164" data-mp="1nqe4oosb27ym">
        {methodSteps.map((step, i) => <React.Fragment key={step.n} data-id="element-165" data-mp="3i2kp8e73a13l" data-mpi={i}>
            <m.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex flex-1 flex-col items-center rounded-2xl border border-slate-200 bg-bg-primary p-6 text-center shadow-card" data-id="element-166" data-mp="3i3m0aio3unlb">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-flash/10" data-id="element-167" data-mp="32klq3ipd3kk5">
                <step.icon size={22} className="text-flash" data-id="element-168" data-mp="3qa6b0752srw2" />
              </div>
              <p className="mt-3 font-heading text-lg font-bold uppercase tracking-wide text-ink" data-id="element-169" data-mp="3v8ra238ld5ix">
                {step.n}. {step.title}
              </p>
              <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-170" data-mp="3heqlu3f9n0wt">{step.text}</p>
            </m.div>
            {i < methodSteps.length - 1 && <ArrowRightIcon size={20} className="mx-auto hidden flex-shrink-0 self-center text-flash/40 sm:block" aria-hidden="true" data-id="element-171" data-mp="d2cw44abovkj" />}
          </React.Fragment>)}
      </div>

      <p className="mx-auto mt-8 max-w-2xl px-4 text-center text-sm leading-relaxed text-muted sm:px-6 sm:text-base" data-id="element-172" data-mp="rmz7xsqw9rpd">
        Sin pasarte horas en YouTube. Sin juntar ejercicios aleatorios que no tienen hilo conductor. Sin
        llegar al patio preguntándote qué vas a hacer cuando los alumnos ya están esperando.
      </p>
    </section>;
}